import React, {Fragment, useEffect, useState} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import ProtectedRoute from '~/routes/ProtectedRoute';
import PublicRoute from '~/routes/PublicRoute';
import {UserAvatarProvider} from '~/pages/context/UserAvatarContext';
import {AppParamsProvider} from '~/pages/context/AppParamsContext';
import {AssetsImageProvider} from '~/pages/context/AssetsImageContext';
import {PlanFeatureProvider} from '~/pages/context/PlanFeatureContext';
import { ToastContainer } from 'react-toastify';
import { Circles } from "react-loader-spinner";
import * as Pages from "~/pages";
import * as Layouts from "~/components/Layout";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWifi} from "@fortawesome/free-solid-svg-icons";
import JsonRoute from '~/assets/routes.json';


function App() {
    const [appRoutes, setAppRoutes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [netWorkFailed, setNetWorkFailed] = useState(false);
    useEffect(() => {
        setAppRoutes(JsonRoute)
        setLoading(false);
    }, []);

    if (loading) {
        return (
            <div style={{
                height: '100vh'
            }} className="d-flex justify-content-center align-items-center flex-column">
                <Circles
                    height="40"
                    width="40"
                    color="#54b4d3"
                    ariaLabel="circles-loading"
                />
                <div className="text-center">
                    <p className="fs-9 mt-3 mb-0">Loading…</p>
                    <p className="fs-9 mt-1">Please wait a moment</p>
                </div>
            </div>
        );
    }
    if (netWorkFailed) {
        return (
            <div style={{
                height: '100vh'
            }} className="d-flex justify-content-center align-items-center flex-column">
                <FontAwesomeIcon icon={faWifi} className="me-2 text-danger fs-6" />
                <div className="text-center">
                    <p className="fs-8-1 mt-2 mb-0 text-danger fw-bold">Network Error</p>
                    <p className="fs-9 mt-2 mb-0">Oops! We couldn’t connect to the server. Please try again later!</p>
                    <a className="fs-9"
                       href="#"
                       onClick={() => window.location.reload()}
                    >Try again</a>
                </div>
            </div>
        );
    }
    return (
        <Fragment>
            <Router>
                <div className="app">
                    <Routes>
                        {appRoutes.map((route, index) => {
                            const Layout = Layouts[route.Layout] || Fragment;
                            const Page = Pages[route.Component];

                            if (!Page) return null;

                            if (route.IsPublic) {
                                if(route.Layout.trim() === 'BreakThroughLayout'){
                                    return (
                                        <Route
                                            key={index}
                                            path={route.Path}
                                            element={
                                                <PublicRoute>
                                                    <AssetsImageProvider>
                                                        <AppParamsProvider>
                                                            <Layout><Page /></Layout>
                                                        </AppParamsProvider>
                                                    </AssetsImageProvider>
                                                </PublicRoute>
                                            }
                                        />
                                    );
                                }
                                return (
                                    <Route
                                        key={index}
                                        path={route.Path}
                                        element={
                                            <AssetsImageProvider>
                                                <AppParamsProvider>
                                                    <Layout><Page /></Layout>
                                                </AppParamsProvider>
                                            </AssetsImageProvider>
                                        }
                                    />
                                );
                            } else {
                                const roles = route.Roles ? route.Roles : [];
                                if(route.Layout == 'AIChatbotLayout'){
                                    return (
                                        <Route
                                            key={index}
                                            path={route.Path}
                                            element={
                                                <ProtectedRoute requiredRoles={roles} area={route.Area}>
                                                    <AssetsImageProvider>
                                                        <UserAvatarProvider>
                                                            <PlanFeatureProvider>
                                                                <Layout><Page /></Layout>
                                                            </PlanFeatureProvider>
                                                        </UserAvatarProvider>
                                                    </AssetsImageProvider>
                                                </ProtectedRoute>
                                            }
                                        />
                                    );
                                }
                                return (
                                    <Route
                                        key={index}
                                        path={route.Path}
                                        element={
                                            <ProtectedRoute requiredRoles={roles} area={route.Area}>
                                                <AssetsImageProvider>
                                                    <UserAvatarProvider>
                                                        <Layout><Page /></Layout>
                                                    </UserAvatarProvider>
                                                </AssetsImageProvider>
                                            </ProtectedRoute>
                                        }
                                    />
                                );
                            }
                        })}
                    </Routes>
                </div>
            </Router>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </Fragment>
    );
}

export default App;
